import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../../assets/Colors';

export const useStyles = makeStyles({
    baseContainer: {},
    container: {
        margin: 0,
        position: 'absolute',
        paddingLeft: 60,
        backgroundColor: 'white',
        minHeight: 40,
        minWidth: 60,
        width: 'auto',
        zIndex: 1002,
    },
    mobileContainer: {
        top: 0,
        borderBottomLeftRadius: 15,
        borderBottomRightRadius: 15,
    },
    desktopContainer: {
        bottom: 0,
        minHeight: 50,
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
    },
    containerPaddingRight: {
        paddingRight: 60,
    },
    toggleMenu: {
        width: 20,
        height: 20,
        padding: 20,
        position: 'absolute',
        left: 7,
    },
    toggleMenuIcon: {
        width: 20,
    },
    reverse: {
        transform: 'rotateZ(180deg)',
    },
    text: {
        fontSize: 15,
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
        color: Colors.text.light,
        lineHeight: '1.2em',
    },
    instructionIcon: {
        width: 40,
        height: 40,
        padding: 5,
        border: '1px solid white',
        borderRadius: '50%',
    },
    textContainer: {
        margin: '5px 20px',
        width: '60%',
    },
    instructionTitle: {
        color: Colors.main.primary,
        fontSize: 18,
        marginBottom: 10,
    },
    instructionText: {},
});
